// Story Functions here
import { Story } from '../Story';
import { IStory } from '../interfaces/IStory';
import { Place } from '../Place';
import { IPlace } from '../interfaces/IPlace';
import { Trail } from '../Trail';
import { ITrail } from '../interfaces/ITrail';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../state/hooks';
import { RootState } from '../../state/store';
import _ from 'lodash';

export const difficulties = [
	'Fully accessible',
	'Easier access',
	'Easy',
	'Moderate',
	'Hard',
	'Challenging',
];

export class StoryHelper {
	public static getTopicsLabel(story: Story | IStory) {
		const topics: string[] = [];
		story.topics.map((topic) => {
			topics.push(_.unescape(topic.title));
			return true;
		});
		return topics.join(' | ');
	}

	public static getPlaceCount(story: Story | IStory) {
		return `${story.fkPlaces.length.toString()} Places`;
	}

	public static getTrailCount(story: Story | IStory) {
		return `${story.fkTrails.length.toString()} Trails`;
	}
	
	public static generateMetaString(story: Story | IStory) {
		const meta = [
			StoryHelper.getPlaceCount(story),
			StoryHelper.getTrailCount(story),
			StoryHelper.getTopicsLabel(story),
		];
		return meta.filter(Boolean).join(' • ');
	}
}

export class PlaceHelper {
	public static getTrailCount(place: Place | IPlace) {
		if (place.fkTrails) {
			const trails = place.fkTrails.length;
			return trails > 1 ? `${trails} Trails` : `${trails} Trail`;
		}
	}

	public static getLocation(place: Place | IPlace) {
		if (place.location_name) {
			return place.location_name;
		}
	}

	public static generateMetaString(place: Place | IPlace) {
		const meta = [
			PlaceHelper.getLocation(place),
			PlaceHelper.getTrailCount(place),
		];
		let topics: string[] = [];
		place.topics.map((topic) => {
			return topic.title;
		});
		const topicString = topics.join(' • ');
		return meta.filter(Boolean).join(' • ');
	}

	public static generateTopicString(place: Place | IPlace) {
		let topics: string[] = [];
		place.topics.map((topic) => {
			topics.push(_.unescape(topic.title));
		});
		return topics.join(' • ');
	}
}

export class TrailHelper {
	public static getDistance(trail: Trail | ITrail, unit: string) {
		if (!trail.distance) return;
		const distance = Math.round((trail.distance / 1000) * 10) / 10;

		if (unit === 'km') {
			return `${distance}km`;
		} else if (unit === 'miles') {
			const miles = Math.floor(distance * 0.621371);
			return `${miles} miles`;
		} else {
			return;
		}
	}

	public static getElevation(trail: Trail | ITrail) {
		if (!trail.location.elevation) return;
		return `${Math.round(trail.location.elevation)}m`;
	}


	public static calcEstTime(distance: number) {
		const km = Math.ceil(distance);
		const avgSpeed = 15;
		const totalMin = km * avgSpeed;
		if(totalMin < 60) {
			return `${totalMin}mins`;
		} else {
			return `${Math.floor(totalMin / 60)}h ${totalMin % 60}m`;
		}
	}

	public static getEstTime(trail: Trail | ITrail) {
		if (!trail.distance) return;

		return this.calcEstTime(trail.distance / 1000);
		// const distance = Math.floor(
		// 	Math.round((trail.distance / 1000) * 10) / 10,
		// );
		// const avgSpeed = 21;
		// const totalMin = distance * avgSpeed;
		// if (Math.floor(totalMin / 60) > 0) {
		// 	return `${Math.floor(totalMin / 60)}h ${totalMin % 60}m`;
		// } else {
		// 	return `${totalMin % 60}mins`;
		// }
	}

	public static getDifficulty(trail: Trail | ITrail) {
		if (!trail.difficulty) return;
		return difficulties[Math.round(trail.difficulty)];
	}

	public static generateMetaString(trail: Trail | ITrail, unit: string) {
		const meta = [
			TrailHelper.getDistance(trail, unit),
			// TrailHelper.getElevation(trail),
			TrailHelper.getEstTime(trail),
			TrailHelper.getDifficulty(trail),
		];
		return meta.filter(Boolean).join(' • ');
	}
}
